import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import { IState } from "@/types/IState";
import { PomodoroStatus } from "@/enums/PomodoroStatus";
import NoSleep from "nosleep.js";

const state: IState = {
    timerInterval: null,
    workMinutes: 25,
    shortBreakMinutes: 5,
    longBreakMinutes: 15,
    totalTime: 25 * 60,
    timerActive: false,
    workCount: 0,
    currentStatus: PomodoroStatus.WORK,
    notificationEnabled: false,
    wakeLockEnabled: false,
    noSleep: new NoSleep(),
    soundEnabled: false,
    sound: new Audio(require("@/assets/sounds/Hermit_Thrush.mp3")),
    vibrationEnabled: false,
    webhook: {
        method: null,
        url: null,
        headers: null,
        data: null
    }
};

export default {
    state,
    mutations,
    getters,
    actions,
    strict: process.env.NODE_ENV !== "production"
};